<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div
        class="flex"
        style="
          padding: 27px 20px;
          background: linear-gradient(180deg, #dcf0ff 0%, rgba(255, 255, 255, 0) 100%);
          border-radius: 4px 4px 0px 0px;
        "
      >
        <!-- <div>
          <img src="@/assets/image/finish.svg" alt="" />
        </div> -->
        <div style="margin-left: 20px">
          <div
            style="
              font-family: MiSans, MiSans;
              font-weight: 500;
              font-size: 18px;
              color: #494c4f;
              line-height: 26px;
            "
          >
            更换网格
          </div>
          <!-- <div
            style="
              font-family: MiSans, MiSans;
              font-size: 12px;
              color: #494c4f;"
          >
            只有一次更改次数，更改后不可更改
          </div> -->
        </div>
      </div>
      <el-form :model="formInline" ref="form" style="padding: 0 24px">
        <el-form-item label="社区" prop="backReason">
          <el-select
            filterable
            placeholder="请选择社区"
            clearable
            v-model="formInline.id1"
            @change="getPointLevelThreeListByIdFun2"
          >
          <!-- :disabled="!!curItem.modifyPointTime ? true : false" -->
            <el-option
              v-for="item in sqOptions"
              :key="item.id"
              :label="item.pointName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="网格" prop="backReason">
          <el-select
            filterable
            placeholder="请选择网格"
            clearable
            v-model="formInline.pointId"
          >
          <!-- :disabled="!!curItem.modifyPointTime ? true : false" -->
            <el-option
              v-for="item in wgOptions"
              :key="item.id"
              :label="item.pointName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- v-if="!curItem.modifyPointTime" -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getPointLevelThreeListById } from "@/api/base.js";

// /extend-report-task/modifyTaskPoint
import { modifyTaskPoint } from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formInline: {
        id1: "",
        id: "",
        pointId: ""
      },
      rules: {
        typeName: [
          { required: true, message: "请输入点位类型", trigger: "blur" }
        ],
        enableStatus: [
          { required: true, message: "请选择是否启用", trigger: "blur" }
        ]
      },
      sqOptions: [],
      wgOptions: []
    };
  },
  mounted() {
    this.getPointLevelThreeListByIdFun();
  },
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      if (!this.formInline.pointId) {
        this.$message({
          type: "error",
          message: "请选择网格"
        });
      }

      let params = {
        pointId: this.formInline.pointId,
        id: this.curItem.taskId
      };
      let res = await modifyTaskPoint(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 分页查询
    async getPointLevelThreeListByIdFun() {
      let params = {
        id: 1
      };
      const res = await getPointLevelThreeListById(params);
      if (res.data.code == 200) {
        this.sqOptions = res.data.data;
        if (this.curItem.communityName) {
          this.formInline.id1 = this.sqOptions.find(
            item => item.pointName == this.curItem.communityName
          ).id;
          this.getPointLevelThreeListByIdFun2(this.formInline.id1, true);
        }
      }
    },
    // 分页查询
    async getPointLevelThreeListByIdFun2(id, isFirst) {
      let params = {
        id: id
      };
      const res = await getPointLevelThreeListById(params);
      if (res.data.code == 200) {
        this.formInline.pointId = "";
        this.wgOptions = res.data.data;
        if (isFirst) {
          this.formInline.pointId = this.wgOptions.find(
            item => item.pointName == this.curItem.blockName
          ).id;
        }
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 0px 0px;
}

/deep/ .el-dialog__header {
  display: none;
}

/deep/.el-input {
  width: auto !important;
}

.flex {
  display: flex;
  align-items: center;
}
/deep/.el-dialog {
  margin-top: 16vh !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/feedbacka/changeWg.vue